const namespace = 'currencies/';
const defaultCurrencyCode = 'EUR';
export const CURRENCIES = Object.freeze({
    GET_ALL: namespace + 'get_all',
    GET_DEFAULT: namespace + 'get_default',
    GET_ACTIVE: namespace + 'get_active',
    GET_BY_ID: namespace + 'get_by_id',
    SET_ALL: namespace + 'set_all',
    SET_ACTIVE: namespace + 'set_active',
});

export default {
    state: () => ({
        currencies: null,
        activeCurrency: null,
    }),
    getters: {
        [CURRENCIES.GET_ALL]: state => state.currencies,
        [CURRENCIES.GET_DEFAULT]: state => {
            if (!state.currencies) return null;
            return state.currencies.find(currency => currency.code === defaultCurrencyCode) || null;
        },
        [CURRENCIES.GET_ACTIVE]: state => {
            if (state.activeCurrency) return state.activeCurrency;
            if (!state.currencies) return null;
            return state.currencies.find(currency => currency.code === defaultCurrencyCode) || null;
        },
        [CURRENCIES.GET_BY_ID]: state => id => {
            if (!state.currencies) return null;
            return state.currencies.find(currency => currency.idCurrency === id) || null;
        },
    },
    mutations: {
        [CURRENCIES.SET_ALL]: (state, currencies) => {
            state.currencies = currencies;
        },
        [CURRENCIES.SET_ACTIVE]: (state, currency) => {
            state.activeCurrency = currency;
        },
    },
    actions: {},
};
